

















































import Vue from 'vue';
import CurrentDateTime from '@/components/Layout/AppBar/CurrentDateTime.vue';
import { Component, Prop } from 'vue-property-decorator';
import SettingsIcon from '@/components/Helper/Icon/Svg/SettingsIcon.vue';
import LogoutIcon from '@/components/Helper/Icon/Svg/LogoutIcon.vue';
import { mapGetters } from 'vuex';
import PointTimer from '@/components/Layout/Layouts/PointTimer.vue';
import { StaffEntity } from '@/entities/staff.entity';
import WorkingTimeTracker from './WorkingTimeTracker.vue';

@Component({
  components: {
    LogoutIcon,
    SettingsIcon,
    CurrentDateTime,
    WorkingTimeTracker,
    PointTimer,
  },
  computed: {
    ...mapGetters('staff', ['currentStaff']),
  },
})
export default class AppBar extends Vue {
  currentStaff!: StaffEntity;

  @Prop()
  value: boolean;

  async logout() {
    await this.$auth.logout();
    await this.$router.push('/login');
  }

  get isAdmin() {
    return this.currentStaff.isAdmin;
  }

  moveToManagementScreen() {
    window.location.href = `${process.env.VUE_APP_SUB_DOMAIN_MANAGER}`;
  }
}
